/* ============================================================
   MARCO MAVERI — PDP Bundle Intelligence (theme JS) — v2
   "Complete the set" bar + variant-selection modal.
   Deterministic engine (mmCategoryOf + MM_COMPLEMENTS + tone
   affinity) mirrors mm-bundle-intelligence/engine.js.
   Markets-safe: fetches prefixed with Shopify.routes.root,
   prices formatted with Intl.NumberFormat(active currency).
   /products.json gotcha: prices are MAJOR-unit strings and
   variants expose option1/2/3 (no options[] array) → normalized.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-mm-bundle]');
  if (!root || root.dataset.mmBundleInit) return;
  root.dataset.mmBundleInit = '1';

  var DISCOUNT_PCT = parseFloat(root.dataset.discount || '0') || 0;
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var LOCALE = document.documentElement.lang || (navigator.language || 'en');
  var CUR_HANDLE = root.dataset.currentHandle;
  var CUR_ID = parseInt(root.dataset.currentId, 10);
  var EYEBROW = root.dataset.eyebrow || 'Complete the set';
  var TITLE = root.dataset.title || 'Wear it as a set.';
  var MM_AFF = null; // n8n brain (assets/mm-affinity.json): popularity + co-purchase affinity
  var MM_AFF_URL = root.dataset.mmAffUrl || '';

  var CAT_I18N = {
    en: { chain: 'Chain', pendant: 'Pendant', bracelet: 'Bracelet', self: 'This piece' },
    fr: { chain: 'Chaîne', pendant: 'Pendentif', bracelet: 'Bracelet', self: 'Cette pièce' },
    de: { chain: 'Kette', pendant: 'Anhänger', bracelet: 'Armband', self: 'Dieses Stück' },
    es: { chain: 'Cadena', pendant: 'Colgante', bracelet: 'Pulsera', self: 'Esta pieza' },
    it: { chain: 'Catena', pendant: 'Ciondolo', bracelet: 'Bracciale', self: 'Questo pezzo' },
    nl: { chain: 'Ketting', pendant: 'Hanger', bracelet: 'Armband', self: 'Dit stuk' },
    pt: { chain: 'Corrente', pendant: 'Pingente', bracelet: 'Pulseira', self: 'Esta peça' },
    pl: { chain: 'Łańcuszek', pendant: 'Wisiorek', bracelet: 'Bransoletka', self: 'Ten element' },
    sv: { chain: 'Kedja', pendant: 'Hänge', bracelet: 'Armband', self: 'Detta smycke' },
    cs: { chain: 'Řetízek', pendant: 'Přívěsek', bracelet: 'Náramek', self: 'Tento kousek' },
    el: { chain: 'Αλυσίδα', pendant: 'Μενταγιόν', bracelet: 'Βραχιόλι', self: 'Αυτό το κόσμημα' },
    hu: { chain: 'Lánc', pendant: 'Medál', bracelet: 'Karkötő', self: 'Ez a darab' },
    ro: { chain: 'Lanț', pendant: 'Pandantiv', bracelet: 'Brățară', self: 'Această piesă' }
  };
  var CAT_LABEL = CAT_I18N[String(LOCALE).slice(0, 2).toLowerCase()] || CAT_I18N.en;
  var MM_COMPLEMENTS = { chain: ['pendant', 'bracelet'], pendant: ['chain', 'bracelet'], bracelet: ['chain', 'pendant'] };
  var MM_TONES = ['gold', 'silver', 'rose gold', 'white gold', 'two tone', 'black', 'titanium', 'diamond', 'zircon'];

  // ---- engine ----
  function parseTags(p) { var t = p && p.tags; if (typeof t === 'string') t = t.split(','); return (t || []).map(function (x) { return String(x).trim().toLowerCase(); }).filter(Boolean); }
  function categoryOf(p) {
    var tags = parseTags(p), has = function (t) { return tags.indexOf(t) !== -1; };
    var type = String((p && (p.product_type || p.type)) || '').toLowerCase();
    var title = String((p && p.title) || '').toLowerCase();
    if (type.indexOf('gift card') !== -1 || /gift\s?card/.test(title)) return 'gift-card';
    if (type === 'sets' || has('sets') || has('set')) return 'set';
    if (type.indexOf('bracelet') !== -1 || has('bracelet')) return 'bracelet';
    if (type.indexOf('necklace') !== -1 || has('necklace') || has('chain') || has('pendant')) {
      if (has('pendant') || has('cross') || has('crucifix')) return 'pendant';
      return 'chain';
    }
    if (has('pendant') || has('cross') || has('crucifix')) return 'pendant';
    if (has('chain') || has('cuban link') || has('rope chain') || has('box chain') || has('tennis') || has('figaro') || has('snake') || has('byzantine') || has('beaded')) return 'chain';
    return 'chain';
  }
  function tonesOf(p) { var tags = parseTags(p); return MM_TONES.filter(function (t) { return tags.indexOf(t) !== -1; }); }
  function isAvail(p) { var vs = p.variants || []; return vs.length === 0 || vs.some(function (v) { return v.available !== false; }); }
  function select(current, catalog, count) {
    count = count || 2;
    var curCat = categoryOf(current), comps = MM_COMPLEMENTS[curCat];
    if (!comps) return { category: curCat, items: [] };
    var curTones = tonesOf(current);
    var pool = catalog
      .filter(function (p) { return p && p.handle !== current.handle && p.id !== current.id; })
      .map(function (p, i) {
        var cat = categoryOf(p), t = tonesOf(p);
        var tone = curTones.reduce(function (s, tn) { return s + (t.indexOf(tn) !== -1 ? 1 : 0); }, 0);
        var score = 0;
        if (MM_AFF) {
          score += ((MM_AFF.popularity && MM_AFF.popularity[p.id]) || 0) * 1;
          var af = MM_AFF.affinity && MM_AFF.affinity[current.id];
          if (af && af[p.id]) score += af[p.id] * 3;
        }
        return { p: p, cat: cat, rank: comps.indexOf(cat), tone: tone, score: score, idx: i };
      })
      .filter(function (x) { return comps.indexOf(x.cat) !== -1 && isAvail(x.p); });
    // rank (category) primary; then real co-purchase + popularity (n8n brain); then tone; then catalog order
    pool.sort(function (a, b) { return a.rank - b.rank || (b.score - a.score) || b.tone - a.tone || a.idx - b.idx; });
    var items = [], perCat = {}, seen = {};
    pool.forEach(function (x) { if (items.length < count && !seen[x.cat]) { items.push(x.p); seen[x.cat] = 1; perCat[x.cat] = 1; } });
    pool.forEach(function (x) { if (items.length < count && items.indexOf(x.p) === -1 && (perCat[x.cat] || 0) < 1) { items.push(x.p); perCat[x.cat] = 1; } });
    return { category: curCat, items: items };
  }

  // ---- money ----
  function toCents(x) { var n = parseFloat(x); return isFinite(n) ? Math.round(n * 100) : 0; }
  function money(cents) { try { return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CUR }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2); } }
  function disc(cents) { return DISCOUNT_PCT > 0 ? Math.round(cents * (1 - DISCOUNT_PCT / 100)) : cents; }

  // ---- catalog (currency-localized, cached) — normalize prices+options ----
  function getCatalog() {
    var key = 'mm_bundle_cat_v2_' + CUR;
    try { var c = sessionStorage.getItem(key); if (c) return Promise.resolve(JSON.parse(c)); } catch (e) {}
    return fetch(ROOT + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var prods = (j && j.products) || [];
        prods.forEach(function (p) {
          (p.variants || []).forEach(function (v) {
            v.price = toCents(v.price);
            if (v.compare_at_price != null) v.compare_at_price = toCents(v.compare_at_price);
            if (!Array.isArray(v.options)) v.options = [v.option1, v.option2, v.option3].filter(function (x) { return x != null && x !== ''; });
          });
          p.optionNames = (p.options || []).map(function (o, i) { return typeof o === 'string' ? o : (o && o.name) || ('Option ' + (i + 1)); });
        });
        try { sessionStorage.setItem(key, JSON.stringify(prods)); } catch (e) {}
        return prods;
      });
  }

  function firstAvail(p) { var vs = p.variants || []; return vs.filter(function (v) { return v.available !== false; })[0] || vs[0] || null; }
  function imgOf(p, v) { if (v && v.featured_image && v.featured_image.src) return v.featured_image.src; if (p.featured_image) return p.featured_image; if (p.images && p.images[0]) return p.images[0]; return ''; }
  function sized(url, w) { return url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  var STATE = { pieces: [] };
  function totals() {
    var was = 0, now = 0;
    STATE.pieces.forEach(function (pc) { var c = pc.variant ? pc.variant.price : 0; was += c; now += disc(c); });
    return { was: was, now: now, save: was - now };
  }

  // ---- bar ----
  function buildBar(current, items) {
    STATE.pieces = [current].concat(items).map(function (p) { return { product: p, variant: firstAvail(p), cat: categoryOf(p) }; });

    var thumbs = STATE.pieces.map(function (pc, i) {
      var src = sized(imgOf(pc.product, pc.variant), 200);
      var lbl = i === 0 ? CAT_LABEL.self : (CAT_LABEL[pc.cat] || pc.cat);
      return '<div class="mmb__item">' +
        '<div class="mmb__thumb">' + (src ? '<img src="' + src + '" alt="" loading="lazy" width="84" height="84">' : '') + '</div>' +
        '<span class="mmb__item-cat notranslate" translate="no">' + esc(lbl) + '</span>' +
        '</div>' + (i < STATE.pieces.length - 1 ? '<span class="mmb__plus" aria-hidden="true">+</span>' : '');
    }).join('');

    var t = totals();
    var price = DISCOUNT_PCT > 0
      ? '<s class="mmb__was">' + money(t.was) + '</s><span class="mmb__now">' + money(t.now) + '</span>'
      : '<span class="mmb__now">' + money(t.was) + '</span>';

    root.innerHTML =
      '<div class="mmb__card">' +
        (DISCOUNT_PCT > 0 ? '<span class="mmb__ribbon">−' + DISCOUNT_PCT + '%</span>' : '') +
        '<div class="mmb__head"><span class="mmb__eyebrow">' + esc(EYEBROW) + '</span><p class="mmb__title">' + esc(TITLE) + '</p></div>' +
        '<div class="mmb__items">' + thumbs + '</div>' +
        '<div class="mmb__foot">' +
          '<div class="mmb__pricing">' +
            '<span class="mmb__count">' + STATE.pieces.length + ' pieces</span>' +
            '<span class="mmb__price">' + price + '</span>' +
            (DISCOUNT_PCT > 0 ? '<span class="mmb__save">You save ' + money(t.save) + '</span>' : '') +
          '</div>' +
          '<button type="button" class="mmb__cta" data-mmb-open>Add the set to cart</button>' +
        '</div>' +
      '</div>';

    root.querySelector('[data-mmb-open]').addEventListener('click', openModal);
    root.hidden = false;
  }

  // ---- modal ----
  function openModal() {
    var modal = document.createElement('div');
    modal.className = 'mmb-modal';
    modal.innerHTML =
      '<div class="mmb-modal__backdrop" data-mmb-close></div>' +
      '<div class="mmb-modal__panel" role="dialog" aria-modal="true" aria-label="Complete the set">' +
        '<button class="mmb-modal__x" data-mmb-close aria-label="Close">&times;</button>' +
        '<div class="mmb-modal__hd">' +
          '<span class="mmb-modal__eyebrow">' + esc(EYEBROW) + '</span>' +
          '<p class="mmb-modal__title">' + esc(TITLE) + '</p>' +
          (DISCOUNT_PCT > 0 ? '<span class="mmb-modal__badge">−' + DISCOUNT_PCT + '% on the set</span>' : '') +
        '</div>' +
        '<div class="mmb-modal__list"></div>' +
        '<div class="mmb-modal__foot">' +
          '<div class="mmb-modal__total"></div>' +
          '<button type="button" class="mmb-modal__add" disabled>Add the set to cart</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    var scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';

    var list = modal.querySelector('.mmb-modal__list');
    STATE.pieces.forEach(function (pc, i) { list.appendChild(pieceRow(pc, i, modal)); });

    function close() { modal.remove(); document.body.style.overflow = ''; window.scrollTo({ top: scrollY, behavior: 'instant' }); }
    modal.querySelectorAll('[data-mmb-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function escFn(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', escFn); } });
    refreshTotal(modal);

    modal.querySelector('.mmb-modal__add').addEventListener('click', function () {
      var btn = this; if (btn.disabled) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      var items = STATE.pieces.filter(function (pc) { return pc.variant && pc.variant.available !== false; }).map(function (pc) { return { id: pc.variant.id, quantity: 1 }; });
      fetch(ROOT + '/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { close(); document.dispatchEvent(new CustomEvent('cart:refresh')); document.dispatchEvent(new CustomEvent('cart:add')); })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add the set to cart'; });
    });
  }

  function pieceRow(pc, idx, modal) {
    var p = pc.product;
    var row = document.createElement('div');
    row.className = 'mmb-piece';
    var hasOpts = (p.variants || []).length > 1;

    function priceEl() {
      var c = pc.variant ? pc.variant.price : 0;
      return DISCOUNT_PCT > 0
        ? '<span class="mmb-piece__price"><s>' + money(c) + '</s><b>' + money(disc(c)) + '</b></span>'
        : '<span class="mmb-piece__price">' + money(c) + '</span>';
    }
    function pills() {
      if (!hasOpts) return '';
      return (p.optionNames || []).map(function (name, oi) {
        var values = [];
        (p.variants || []).forEach(function (v) { var val = v.options[oi]; if (val && values.indexOf(val) === -1) values.push(val); });
        if (values.length < 2 && (p.optionNames || []).length === 1) { /* keep single shown for clarity */ }
        var html = values.map(function (val) {
          var avail = (p.variants || []).some(function (v) { return v.options[oi] === val && v.available !== false; });
          var sel = pc.variant && pc.variant.options[oi] === val;
          return '<button type="button" class="mmb-pill' + (sel ? ' is-sel' : '') + (avail ? '' : ' is-out') + '" data-oi="' + oi + '" data-val="' + esc(val) + '"' + (avail ? '' : ' disabled') + '>' + esc(val) + '</button>';
        }).join('');
        return '<div class="mmb-piece__opt"><span class="mmb-piece__opt-name">' + esc(name) + '</span><div class="mmb-pills">' + html + '</div></div>';
      }).join('');
    }
    function render() {
      var lbl = idx === 0 ? CAT_LABEL.self : (CAT_LABEL[pc.cat] || pc.cat);
      row.innerHTML =
        '<a class="mmb-piece__media" href="' + esc(p.url) + '" target="_blank" rel="noopener"><div class="mmb-piece__img"><img src="' + sized(imgOf(p, pc.variant), 200) + '" alt="" width="80" height="80"></div></a>' +
        '<div class="mmb-piece__body">' +
          '<span class="mmb-piece__cat notranslate" translate="no">' + esc(lbl) + '</span>' +
          '<a class="mmb-piece__name" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(p.title) + '</a>' +
          priceEl() + pills() +
        '</div>';
      row.querySelectorAll('.mmb-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          var oi = parseInt(pill.dataset.oi, 10), val = pill.dataset.val;
          var target = pc.variant ? pc.variant.options.slice() : p.variants[0].options.slice();
          target[oi] = val;
          var match = (p.variants || []).find(function (v) { return v.options.every(function (o, k) { return k === oi ? o === val : o === target[k]; }) && v.available !== false; })
            || (p.variants || []).find(function (v) { return v.options[oi] === val && v.available !== false; })
            || (p.variants || []).find(function (v) { return v.options[oi] === val; });
          if (match) pc.variant = match;
          render(); refreshTotal(modal);
        });
      });
    }
    render();
    return row;
  }

  function refreshTotal(modal) {
    var allResolved = STATE.pieces.every(function (pc) { return pc.variant && pc.variant.available !== false; });
    var t = totals();
    modal.querySelector('.mmb-modal__total').innerHTML =
      '<span class="mmb-modal__total-lbl">Total</span>' +
      '<span class="mmb-modal__total-val">' +
        (DISCOUNT_PCT > 0 ? '<s class="mmb-modal__was">' + money(t.was) + '</s>' : '') +
        '<b class="mmb-modal__now">' + money(t.now) + '</b>' +
        (DISCOUNT_PCT > 0 ? '<span class="mmb-modal__save">You save ' + money(t.save) + '</span>' : '') +
      '</span>';
    var add = modal.querySelector('.mmb-modal__add');
    add.disabled = !allResolved;
    add.textContent = allResolved ? 'Add the set to cart' : 'Select all options';
  }

  // ---- init ----
  function fetchAffinity() {
    if (!MM_AFF_URL) return Promise.resolve();
    return fetch(MM_AFF_URL).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j.popularity) MM_AFF = j; }).catch(function () {});
  }
  Promise.all([getCatalog(), fetchAffinity()]).then(function (_r) {
    var catalog = _r[0];
    var current = catalog.filter(function (p) { return p.handle === CUR_HANDLE || p.id === CUR_ID; })[0];
    if (!current) { root.hidden = true; return; }
    var res = select(current, catalog, 2);
    if (!res.items || res.items.length < 2) { root.hidden = true; return; }
    buildBar(current, res.items);
  }).catch(function () { root.hidden = true; });
})();
